/**
 * @generated SignedSource<<1388795b3d8dcd1190e42562a8d15bf0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarAuctionItemsCarouselLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarAuctionItemsCarousel_viewer">;
  readonly " $fragmentType": "PdpSharedSimilarAuctionItemsCarouselLazy_viewer";
};
export type PdpSharedSimilarAuctionItemsCarouselLazy_viewer$key = {
  readonly " $data"?: PdpSharedSimilarAuctionItemsCarouselLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarAuctionItemsCarouselLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarAuctionItemsCarouselLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarAuctionItemsCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "11274294fc31700e51ec90853fffb83b";

export default node;
